export enum ColorScheme {
    System = "System",
    Light = "Light",
    Dark = "Dark",
}
